import type { AnalyticsClient } from '@3plearning/mx-teacher-analytics';
import { useTimeOnPage } from '@3plearning/mx-teacher-analytics/react';
import React, {
    useEffect, useRef
} from 'react';
import { useLocation } from 'react-router-dom';

import type { AppEvents } from './events';
import { useAnalyticsClient } from './use-analytics-client';
import { useAnalyticsIdentity } from './use-analytics-identity';
import { useClassContext } from './use-class-context';

const usePageTracking = (isIdentityReady: boolean) => {
    const client = useAnalyticsClient();
    const location = useLocation();
    const classContext = useClassContext();
    const classContextRef = useRef(classContext);
    const previousPathRef = useRef<string | null>(null);

    // Read through a ref, so a class change doesn't send another page view.
    classContextRef.current = classContext;

    useEffect(() => {
        if (!client || !isIdentityReady) return;

        const currentPath = location.pathname;

        if (previousPathRef.current === currentPath) return;

        client.track('page.view', {
            ...classContextRef.current,
            path: currentPath
        });
        client.trackSession(currentPath);
        previousPathRef.current = currentPath;
    }, [client, isIdentityReady, location.pathname]);
};
const TimeOnPageTracker = ({ client }: { client: AnalyticsClient<AppEvents> }) => {
    useTimeOnPage(client);

    return null;
};

export const AnalyticsListener = () => {
    const client = useAnalyticsClient();
    const isIdentityReady = useAnalyticsIdentity();

    usePageTracking(isIdentityReady);

    if (!client || !isIdentityReady) return null;

    return <TimeOnPageTracker client={client} />;
};
